import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import CloseIcon from '../../themes/svg/closeIcon';
import * as steps from './steps/stepTypes';
import SelectMany from './steps/SelectManyConnector';
import CraftEmail from './steps/CraftEmailConnector';
import EstimateShared from './steps/EstimateShared';

const modalTitles = {
  [steps.SELECT_MANY]: 'Choose Estimate(s) to Share',
  [steps.CRAFT_EMAIL]: 'Share Estimate(s)',
  [steps.SUCCESSFUL_SHARE]: 'Estimate(s) Shared',
};

class ShareEstimateModal extends Component {
  componentWillMount() {
    Modal.setAppElement('#estimateBuilderRoot');
  }

  onStep = givenStep => this.props.step === givenStep;

  advanceToCraft = () => {
    this.changeStep(steps.CRAFT_EMAIL);
  };

  changeStep = (step) => {
    this.props.shareModal(step);
  };

  toggleModalAndResetState = () => {
    // this.resetState();
    this.props.dismissShareModal();
  };

  resetState = () => {
    this.props.InitializeShareStore(this.props.selectedEstimateId);
    this.changeStep(steps.SELECT_MANY);
  };

  render = () => (
    <Modal
      isOpen={this.props.shareModalOpen}
      className="estimatebuilder-modal"
      onRequestClose={this.toggleModalAndResetState}
      overlayClassName="estimatebuilder-modal-overlay"
      style={{
        content: {
          width: 750,
          position: 'relative',
          top: '10%',
          transform: 'translateX(-50%)',
        },
      }}
    >
      <div className="share-modal">
        <h2>{modalTitles[this.props.step]}</h2>
        <div
          className="modal-close"
          onClick={this.toggleModalAndResetState}
          tabIndex="-1"
          role="button"
        >
          <CloseIcon />
        </div>
        <div className="modal-body">
          {this.onStep(steps.SELECT_MANY) && <SelectMany advance={this.advanceToCraft} />}
          {this.onStep(steps.CRAFT_EMAIL) && <CraftEmail />}
          {this.onStep(steps.SUCCESSFUL_SHARE) &&
            <EstimateShared close={this.toggleModalAndResetState} />}
        </div>
      </div>
    </Modal>
  );
}

ShareEstimateModal.propTypes = {
  shareModalOpen: PropTypes.bool.isRequired,
  selectedEstimateId: PropTypes.string.isRequired,
  shareModal: PropTypes.func.isRequired,
  dismissShareModal: PropTypes.func.isRequired,
  InitializeShareStore: PropTypes.func.isRequired,
  step: PropTypes.number,
};

ShareEstimateModal.defaultProps = {
  step: steps.SELECT_MANY,
};

export default ShareEstimateModal;
